import { AfterViewChecked, Component, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs';
import { Menu } from 'src/app/model/shared/menu';
import { entraAuthService } from 'src/app/service/auth.service';
import { ConfigService } from 'src/app/service/config.service';
import { ContentfulService } from 'src/app/service/contentful.service';
import { config } from 'src/environments/environment';

declare function topMenu(): any;
declare var gtag: any;

@Component({
  selector: 'app-top-menu',
  templateUrl: './top-menu.component.html',
  styleUrls: ['./top-menu.component.scss']
})
export class TopMenuComponent implements OnInit, AfterViewChecked {
  menu: Menu = {} as Menu;
  categoryMap = new Map();
  linkMap = new Map();
  disableMenu = false;
  isUserLoggedIn = false;

  constructor(public configService: ConfigService, private router: Router, private contentfulService: ContentfulService, private authService: entraAuthService) {}

  ngOnInit(): void {
    this.menu.tabs = [];
    this.router.events.pipe(filter((e) => e instanceof NavigationEnd)).subscribe((event: any) => {
      if (event.url !== '/akamai/sureroute-test-object.html') {
        const query = { 'fields.name': 'Top Menu' };
        this.contentfulService.getMenuContentWithItems(query).then((menuItems) => {
          this.menu.tabs = menuItems[0]?.fields.jsonData;
          this.processJSONData();
          topMenu();
        });
      }
    });
  }

  closeNav() {
    const element = document.getElementsByClassName('nav-menus-wrapper-close-button')[0] as HTMLElement;
    element?.click();
  }

  private processJSONData() {
    this.menu.tabs.forEach((tab) => {
      const categories = tab.links?.filter((link) => link.category === undefined);
      if (categories !== undefined) {
        this.categoryMap.set(tab.title, categories);
      }
    });
    [...this.categoryMap.values()].flat(1).forEach((category) => {
      this.menu.tabs.forEach((tab) => {
        const links = tab.links?.filter((link) => link.category === category.title);
        if (links !== undefined && links.length !== 0) {
          this.linkMap.set(
            category.title,
            tab.links?.filter((link) => link.category === category.title)
          );
        }
      });
    });
  }
  ngAfterViewChecked(): void {
    if (window.location.pathname === '/account/register') {
      this.disableMenu = true;
    }
  }

  navigateToLink(url: string, title?: string): void {
    this.trackAgencyPortalNavigation(url, title);
    const [path, queryString] = url.split('?');
    const queryParams: any = {};
    if (queryString) {
      queryString.split('&').forEach((param) => {
        const [key, value] = param.split('=');
        queryParams[key] = decodeURIComponent(value);
      });
    }
    this.router.navigate([path], { queryParams });
  }

  get userLoggedIn() {
    return this.authService.isLoggedIn();
  }

  private isAgencyPortalLink(url: string): boolean {
    return !!url && url.trim().toLowerCase().includes('faq-portal');
  }

  private trackAgencyPortalNavigation(url: string, title?: string): void {
    if (this.isAgencyPortalLink(url) && config.enableCookies && typeof gtag !== 'undefined') {
      gtag('event', 'ndc_agency_portalFAQ_link_click', {
        event_category: 'Top Menu',
        event_label: title ?? 'British Airways NDC Agency Portal',
        destination_url: url,
        transport_type: 'beacon'
      });
    }
  }
}
